import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'home',
    component: resolve => require(['@/views/home/index'], resolve),
    meta: {
      title: '搜精品',
      keepAlive: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: resolve => require(['@/views/search/index'], resolve),
    meta: {
      title: '搜索'
    }
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: resolve => require(['@/views/classification/indexSeach'], resolve),
    meta: {
      title: '搜索列表'
    }
  },
  {
    path: '/classifyList',
    name: 'classifyList',
    component: resolve => require(['@/views/classification/indexClassify'], resolve),
    meta: {
      title: '列表'
    }
  },
  {
    path: '/classify',
    name: 'Login',
    component: resolve => require(['@/views/login/index'], resolve),
    meta: {
      title: '分类',
      keepAlive: true
    }
  },
  // 分类管理页面
  {
    path: '/classification',
    name: 'classification',
    component: resolve => require(['@/views/classification/index'], resolve),
    meta: {
      title: '列表',
      keepAlive: true,
      isBack: false
    }
  },
  // 分类管理页面
  {
    path: '/Advertising',
    name: 'Advertising',
    component: resolve => require(['@/views/classification/Advertising'], resolve),
    meta: {
      title: '活动页面'
    }
  },
  // 商品详情
  {
    path: '/CommodityDetails',
    name: 'CommodityDetails',
    component: resolve => require(['@/views/CommodityDetails/index'], resolve),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/addressList',
    name: 'addressList',
    component: resolve => require(['@/views/addressList/index'], resolve),
    meta: {
      title: '地址管理'
    }
  },
  // 优惠券列表
  {
    path: '/Coupon',
    name: 'Coupon',
    component: resolve => require(['@/views/OrderPage/Coupon'], resolve),
    meta: {
      title: '优惠券'
    }
  },
  {
    path: '/addressData',
    name: 'addressData',
    component: resolve => require(['@/views/addressList/addressData'], resolve),
    meta: {
      title: '地址列表'
    }
  },
  {
    path: '/EvaluationPage/:id',
    name: 'EvaluationPage',
    component: resolve => require(['@/views/EvaluationPage/index'], resolve),
    meta: {
      title: '商品评价'
    }
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: resolve => require(['@/views/order/orderList'], resolve),
    meta: {
      title: '订单列表',
      keepAlive: true,
      isBack: false
    }
  },
  // 订单详情
  {
    path: '/orderInfo/:id',
    name: 'orderInfo',
    component: resolve => require(['@/views/order/orderInfo'], resolve),
    meta: {
      title: '订单详情'
    }
  },
  // 查看物流
  {
    path: '/orderCourier',
    name: 'orderCourier',
    component: resolve => require(['@/views/order/orderCourier'], resolve),
    meta: {
      title: '查看物流'
    }
  },
  // 支付
  {
    path: '/pay',
    name: 'pay',
    component: resolve => require(['@/views/order/pay'], resolve),
    meta: {
      title: '支付'
    }
  },
  // 支付
  {
    path: '/paycenter',
    name: 'paycenter',
    component: resolve => require(['@/views/order/paycenter'], resolve),
    meta: {
      title: '支付'
    }
  },
  // 支付-支付宝
  {
    path: '/payali',
    name: 'payali',
    component: resolve => require(['@/views/OrderPage/payali'], resolve),
    meta: {
      title: '支付宝支付'
    }
  },
  // 支付-微信
  {
    path: '/paywx',
    name: 'paywx',
    component: resolve => require(['@/views/OrderPage/paywx'], resolve),
    meta: {
      title: '微信支付'
    }
  },
  // 订单页面
  {
    path: '/OrderPage',
    name: 'OrderPage',
    component: resolve => require(['@/views/OrderPage/index'], resolve),
    meta: {
      title: '填写订单'
    }
  },
  // 购物车
  {
    path: '/ShoppingCart',
    name: 'ShoppingCart',
    component: resolve => require(['@/views/ShoppingCart/ShoppingCart'], resolve),
    meta: {
      title: '购物车'
    }
  },
  // 领取福利
  {
    path: '/couponlist',
    name: 'couponlist',
    component: resolve => require(['@/views/home/couponlist'], resolve),
    meta: {
      title: '领取福利'
    }
  },
  {
    path: '/active1',
    name: 'active1',
    component: resolve => require(['@/views/home/active1'], resolve),
    meta: {
      title: '分类'
    }
  },
  // 订单页面
  {
    path: '/CommodityEvaluation',
    name: 'CommodityEvaluation',
    component: resolve => require(['@/views/CommodityEvaluation/index'], resolve),
    meta: {
      title: '点评商品'
    }
  },
  // 售后服务
  {
    path: '/afterSale',
    name: 'afterSale',
    component: resolve => require(['@/views/afterSale/afterSale'], resolve),
    meta: {
      title: '售后服务'
    }
  },
  // 售后记录
  {
    path: '/afterrecords',
    name: 'afterrecords',
    component: resolve => require(['@/views/afterSale/afterrecords'], resolve),
    meta: {
      title: '售后详情'
    }
  },
  // 申请退货
  {
    path: '/ReturnGoods',
    name: 'ReturnGoods',
    component: resolve => require(['@/views/afterSale/ReturnGoods'], resolve),
    meta: {
      title: '申请退货'
    }
  },
  // 申请退款
  {
    path: '/refund',
    name: 'refund',
    component: resolve => require(['@/views/afterSale/refund'], resolve),
    meta: {
      title: '申请退款'
    }
  },
  // 进度
  {
    path: '/Speed',
    name: 'Speed',
    component: resolve => require(['@/views/afterSale/Speed'], resolve),
    meta: {
      title: '售后进度'
    }
  },
  // 售后记录
  {
    path: '/records',
    name: 'records',
    component: resolve => require(['@/views/afterSale/records'], resolve),
    meta: {
      title: '售后记录'
    }
  },
  // 进度
  {
    path: '/paysuess',
    name: 'paysuess',
    component: resolve => require(['@/views/order/paysuess'], resolve),
    meta: {
      title: '支付结果'
    }
  },
  // 敬请期待
  {
    path: '/ComingSoon',
    name: 'ComingSoon',
    component: resolve => require(['@/views/ComingSoon/index'], resolve),
    meta: {
      title: '敬请期待'
    }
  }

]

const router = new VueRouter({
  routes,
  base: getAbsolutePath()
})

router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(from)
  if (to.name === 'home') {
    localStorage.setItem('footer', 0)
  }
  if (to.name === 'Login') {
    localStorage.setItem('footer', 1)
  }
  if (to.name === 'orderList') {
    localStorage.setItem('footer', 3)
  }
  // 修改标题
  // if (from.name === 'home' && to.name === 'searchList') {
  //   if (to.meta.title) {
  //     document.title = to.query.name
  //     localStorage.setItem('titleName', to.query.name)
  //     console.log(localStorage.getItem('titleName'))
  //   }
  // } else if (from.name === 'home' && to.name === 'classifyList') {
  //   document.title = to.query.name
  //   localStorage.setItem('titleName', to.query.name)
  //   console.log(localStorage.getItem('titleName'))
  // } else if (from.name === 'home' && to.name === 'classification') {
  //   document.title = to.query.name
  //   localStorage.setItem('titleName', to.query.name)
  //   console.log(localStorage.getItem('titleName'))
  // } else {
  //   document.title = to.meta.title
  //   localStorage.setItem('titleName', to.meta.title)
  //   console.log(localStorage.getItem('titleName'))
  // }
  if (to.query.name) {
    document.title = to.query.name
    localStorage.setItem('titleName', to.query.name)
    console.log(localStorage.getItem('titleName'))
  } else {
    document.title = to.meta.title
    localStorage.setItem('titleName', to.meta.title)
    console.log(localStorage.getItem('titleName'))
  }
  next()
})
export default router

function getAbsolutePath () {
  console.log(location.pathname)
  const path = location.pathname
  return path.substring(0, path.lastIndexOf('/') + 1)
}
